module.exports = __webpack_public_path__ + "media/images/demo_tests/theswitch-68cb5031308bb6641526b33f7f02bf20.gif";